<div class="">
    <!-- Stats -->
    <div class="h7 lato-bold color-whaleTail">Stats</div>
    <div class="content mb-3 p-3">
        <!-- Coins and Orders -->
        <div class="row">
            <div class="col-4 my-3 ml-4 cursor-pointer" (click)="changeCurrentPage('coin')" title="See All Coins">
                <div class="row">
                    <div class="col-3 d-flex align-items-center">
                        <img class="icon-40" src="../../../App_Themes/clearview-default/icons/colorful/coins.svg">
                    </div>
                    <div class="col-9 ml-n2">
                        <div class="lato-bold font-size-28 color-whaleTail">
                            {{userProfile.AvailableSpendingPoints | number : '1.0-0'}}
                        </div>
                        <div class="lato-regular color-whaleTail" cvLocalizedText langSection="Users" langKey="Coins">
                            Coins
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-4 my-3 ml-4 cursor-pointer" (click)="changeCurrentPage('order')" title="See All Orders">
                <div class="row">
                    <div class="col-3 d-flex align-items-center">
                        <img class="icon-40" src="../../../App_Themes/clearview-default/icons/colorful/marketplace.svg">
                    </div>
                    <div class="col-9 ml-n2">
                        <div class="lato-bold font-size-28 color-whaleTail">
                            {{orderList.length | number : '1.0-0'}}
                        </div>
                        <div class="lato-regular color-whaleTail" cvLocalizedText langSection="Users" langKey="Orders">
                            Orders
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Gems and Challenges Won -->
        <div class="row">
            <div class="col-4 my-3 ml-4 cursor-pointer" (click)="changeCurrentPage('gem')" title="See All Gems">
                <div class="row">
                    <div class="col-3 d-flex align-items-center">
                        <img class="icon-40" src="../../../App_Themes/clearview-default/icons/colorful/gems.svg">
                    </div>
                    <div class="col-9 ml-n2">
                        <div class="lato-bold font-size-28 color-whaleTail">
                            {{userProfile.AvailableGems | number : '1.0-0'}}
                        </div>
                        <div class="lato-regular color-whaleTail" cvLocalizedText langSection="Users" langKey="Gems">
                            Gems
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-4 my-3 ml-4">
                <div class="row">
                    <div class="col-3 d-flex align-items-center">
                        <img class="icon-40" src="../../../App_Themes/clearview-default/icons/colorful/challenges.svg">
                    </div>
                    <div class="col-9 ml-n2">
                        <div class="lato-bold font-size-28 color-whaleTail">{{challengeWon}}</div>
                        <div class="lato-regular color-whaleTail" cvLocalizedText langSection="Users" langKey="Challenges_Won">
                            Challenges Won
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Badges and Level XP -->
        <div class="row">
            <div class="col-4 my-3 ml-4 cursor-pointer" (click)="changeCurrentPage('badge')" title="See All Badges">
                <div class="row">
                    <div class="col-3 d-flex align-items-center">
                        <img class="icon-40" src="../../../App_Themes/clearview-default/icons/colorful/badges.svg">
                    </div>
                    <div class="col-9 ml-n2">
                        <div class="lato-bold font-size-28 color-whaleTail">
                            {{badgeNum}}
                        </div>
                        <div class="lato-regular color-whaleTail" cvLocalizedText langSection="Users" langKey="Badges">
                            Badges
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-4 my-3 ml-4">
                <div class="row">
                    <div class="col-3 d-flex align-items-center">
                        <img class="icon-40" src="../../../App_Themes/clearview-default/icons/colorful/levels.svg">
                    </div>
                    <div class="col-9 ml-n2">
                        <div class="lato-bold font-size-28 color-whaleTail">{{userProfile.CurrentLevel  | number : '1.0-0'}} | {{userProfile.LifetimeXP  | number : '1.0-0'}}</div>
                        <div class="lato-regular color-whaleTail" cvLocalizedText langSection="Users" langKey="Level_Title">Level | XP</div>
                        <div class="game_black_progress_bar">
                            <div class="game_black_progress_value">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Recent Badges -->
    <div class="d-flex justify-content-between">
        <div class="h7 lato-bold color-whaleTail" cvLocalizedText langSection="Users" langKey="Recent_Badges">Recent Badges</div>
        <div class="mt-3" (click)="changeCurrentPage('badge')">
            <a cvLocalizedText langSection="Users" langKey="See_All">See All</a>
        </div>
    </div>
    <div class="content mb-3 p-3">
        <div class="row">
            <div class="col-2 recent_badge" *ngFor="let preview of previewBadges">
                <img [src]="'../Admin/ImageResizer.aspx?imgid=' + preview.ImageID + '&w=75&h=75'"
                     class="preview_badge" [hidden]="preview.ImageID == 0" />
                {{preview.badgeName}}
                <br />
                <span class="preview_badge_date">{{preview.earnedDate}}</span>
            </div>
        </div>
    </div>
    <div class="d-flex justify-content-between">
        <div class="h7 lato-bold color-whaleTail" cvLocalizedText langSection="Users" langKey="Recent_Marketplace_Orders">Recent Marketplace Orders</div>
        <div class="mt-3" (click)="changeCurrentPage('order')">
            <a cvLocalizedText langSection="Users" langKey="See_All">See All</a>
        </div>
    </div>
    <div class="content mb-3">
        <div class="row recent_div_title">
            <div class="col-6">
            </div>
            <div class="col-6">
            </div>
        </div>
        <div>
            <div class="game_preview_order_status">
                <div class="col-2 text_align_center">
                    <span cvLocalizedText langSection="Users" langKey="Order_Number">Order Number</span>
                </div>
                <div class="col-2 text_align_center">
                    <span cvLocalizedText langSection="Users" langKey="Date_Ordered">Date Ordered</span>
                </div>
                <div class="col-2 text_align_center">
                    <span cvLocalizedText langSection="Users" langKey="Total_Coins">Total Coins</span>
                </div>
                <div class="col-2 text_align_center">
                    <span cvLocalizedText langSection="Users" langKey="Status">Status</span>
                </div>
                <div class="col-4 text_align_center">
                    <span cvLocalizedText langSection="Users" langKey="Notes">Notes</span>
                </div>
            </div>
        </div>
        <div class="usersList" style="width:100%;height:auto;max-height: none;">
            <div class="row " *ngFor="let order of previewOrders; let i = index;" style="border-bottom: 1px solid #E0E3E6;">
                <div class="table_data col-2 text_align_center">
                    <svg class="icon-16 fill-valyrianSteel game_recent_order_arrow" *ngIf="ifShowOrderDetail[i] == 0" title="Click to expand"
                         style="margin-right: 30px; cursor: pointer;" (click)="expandOrder(i)">
                        <use href="..\App_Themes\clearview-default\icons\utility\arrow-right.svg#arrow-right"></use>
                    </svg>
                    <svg class="icon-16 fill-valyrianSteel game_recent_order_arrow" *ngIf="ifShowOrderDetail[i] == 1" title="Click to expand"
                         style="margin-right: 30px; cursor: pointer;" (click)="expandOrder(i)">
                        <use href="..\App_Themes\clearview-default\icons\utility\arrow-down.svg#arrow-down"></use>
                    </svg>
                    <span>{{order.PointStoreOrderID}}</span>
                </div>
                <div class="table_data col-2 text_align_center"><span>{{order.DateOrdered}}</span></div>
                <div class="table_data col-2 text_align_center"><span>{{order.OrderTotal}}</span></div>
                <div class="table_data col-2 text_align_center"><span>{{order.OrderStatusName}}</span></div>
                <div class="table_data col-4 text_align_center"><span>{{order.Note}}</span></div>
                <div *ngIf="ifShowOrderDetail[i] == 1" class="col-12 game_recent_order_dropdown">
                    <div style="clear:both; width:100%;font-size:14px; margin-bottom: 5px;" *ngFor="let item of order.ProductsCollection"
                         class="row pl-5">
                        <div class="col-2">
                            <img [src]="order.ProductsCollection[0]._PointStoreProductOrderedDTO.ProductImageID == 0 ? '../Admin/ImageResizer.aspx?imgid=-15&w=auto&h=40' : '../Admin/ImageResizer.aspx?imgid=' + item._PointStoreProductOrderedDTO.ProductImageID + '&w=auto&h=40'"
                                 style="height:100%; max-width: 100%" />
                        </div>
                        <div class="col-10">
                            <span><b>{{item._PointStoreProductOrderedDTO.Title}}</b></span>
                            <br>
                            <span>{{item._PointStoreProductOrderedDTO.ProductQuantity}} &nbsp;ordered</span>
                            <br>
                            <span>{{item._PointStoreProductOrderedDTO.ProductCost}} &nbsp;coins</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="previewOrders.length == 0" class="m-3">
            <span class="color-whaleTail" cvLocalizedText langSection="Users" langKey="There_No_Order">No order history.</span>
        </div>
    </div>
</div>
<!-- Popup views for detail pages -->
<cv-gamification-detail-page *ngIf="currentPage == 'coin'" [(currentPage)]="currentPage" [(datatransfer)]="coinData"
                             [(userProfile)]="userProfile" [userInfo]="userInfo" [admin]="adminID"></cv-gamification-detail-page>
<cv-gamification-detail-page *ngIf="currentPage == 'gem'" [(currentPage)]="currentPage" [datatransfer]="gemData"
                             [userProfile]="userProfile" [userInfo]="userInfo" [admin]="adminID"></cv-gamification-detail-page>
<cv-gamification-detail-page *ngIf="currentPage == 'badge'" [(currentPage)]="currentPage" [datatransfer]="badgeList"
                             [userProfile]="userProfile" [userInfo]="userInfo" [badgeNum]="badgeNum"></cv-gamification-detail-page>
<cv-gamification-detail-page *ngIf="currentPage == 'order'" [(currentPage)]="currentPage" [datatransfer]="orderList"
                             [userProfile]="userProfile" [userInfo]="userInfo"></cv-gamification-detail-page>
